import { Skeleton, Stack } from '@mui/material';

export const CustomersPageNavigationLayoutLoadingData: React.FC = () => {
  return (
    <Stack
      direction="row"
      spacing={2.5}
      sx={{
        alignItems: "center",
        px: 5,
        py: 0,
        height: "104px",
        backgroundColor: '#FAFBFD',
        borderBottom: '1px solid #d6dbe7'
      }}>
      <Skeleton variant="circular" width={40} height={40} />
      <Stack spacing={1} sx={{
        flexGrow: 1
      }}>
        <Skeleton variant="text" width={200} height={32} />
        <Skeleton variant="text" width={300} height={20} />
      </Stack>
      <Skeleton variant="rectangular" width={150} height={64} />
    </Stack>
  );
};
